import styled from "styled-components/macro";

const DivBackgroundColor = styled.div<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor};
`;

export default DivBackgroundColor;
